// Full-screen "site is being updated" page shown to public visitors while
// maintenance mode is on. Admin routes bypass this.
import { Wrench } from 'lucide-react';

export default function MaintenanceScreen({ message }: { message: string }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      textAlign: 'center', padding: 24,
      background: 'radial-gradient(circle at 50% 30%, #15140f 0%, #0a0a0b 60%)',
      color: '#fff',
    }}>
      <div style={{
        width: 72, height: 72, borderRadius: 20,
        background: 'rgba(212,175,55,0.1)', border: '1px solid rgba(212,175,55,0.25)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 28,
        boxShadow: '0 8px 32px rgba(212,175,55,0.15)',
      }}>
        <Wrench style={{ width: 32, height: 32, color: 'var(--color-accent)', animation: 'wrenchPulse 2.4s ease-in-out infinite' }} />
      </div>

      <h1 style={{ fontSize: 30, fontWeight: 700, letterSpacing: '-0.02em', margin: '0 0 14px' }}>
        We&rsquo;ll be right back
      </h1>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: 'rgba(255,255,255,0.55)', maxWidth: 480, margin: 0 }}>
        {message}
      </p>

      <div style={{ marginTop: 36, display: 'flex', alignItems: 'center', gap: 8 }}>
        <span className="mdot" style={{ animationDelay: '0s' }} />
        <span className="mdot" style={{ animationDelay: '0.2s' }} />
        <span className="mdot" style={{ animationDelay: '0.4s' }} />
      </div>

      <p style={{ position: 'absolute', bottom: 28, fontSize: 12, color: 'rgba(255,255,255,0.25)', margin: 0 }}>
        ch-varun.xyz
      </p>

      <style>{`
        @keyframes wrenchPulse { 0%,100% { transform: rotate(-8deg); } 50% { transform: rotate(8deg); } }
        @keyframes mdotBlink { 0%,100% { opacity: 0.25; } 50% { opacity: 1; } }
        .mdot { width: 8px; height: 8px; border-radius: 50%; background: var(--color-accent); display: inline-block; animation: mdotBlink 1.2s ease-in-out infinite; }
      `}</style>
    </div>
  );
}
